

import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid,
    useMediaQuery, useTheme, FormHelperText, Icon, FormControlLabel, Radio, Typography, FormControl, RadioGroup
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import Scrollbars from "rc-scrollbars";
import { InputBaseField, SelectField, CheckboxField, TextareaField } from "../../../../../../../components/InputField/InputField";
import useStyles from './styles';
import { useRef, useState } from "react";
import { Label } from "../../../../../../../components/UiElements/UiElements";
import { useEffect } from "react";
import addDonorIcon from "../../../../../../../assets/img/addIcon.svg";
import {
    allowedAttachmentsImages
} from "../../../../../../../../src/components/Common/Extensions";
import { withSnackbar } from "../../../../../../../components/Message/Alert";
import { PostDataAPI } from "../../../../../../../Services/APIService";
import DialogLoader from "../../../../../../../components/Loader/DialogLoader";
function AddCashDisbursement({ handleClose, handleSuccessClose, isOpen, ...props }) {
    const classes = useStyles();
    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const inputFile = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState("")
    const [isLoading, setIsLoading] = useState(false);


    const handleFileUpload = () => {
        inputFile.current.click();
    }
    const handleFileChange = (event) => {
        const file = event.target.files[0]
        setSelectedFile(file);
        setFileName(file.name)

    };

    const [selectedDonorType, setSelectedDonorType] = useState('oneTime');
    const handleOptionChange = (event) => {
        const { name, value, type, checked } = event.target;
        setSelectedDonorType(event.target.value);

        setState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };


    useEffect(() => {

    }, [])


    const [dropdown, setDropdown] = useState([
        "Value1", "Value2", "Value3"
    ]);


    const [organizationList, setOrganizationList] = useState(
        [
            "Value1", "Value2", "Value3"
        ]
    );




    const [showDetails, setShowDetails] = useState(false);
    const [state, setState] = useState({ paymentOninstallments: false, paymentType: 'oneTime' });
    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        const newValue = type === 'checkbox' ? checked : value;

        setState((prevState) => ({
            ...prevState,
            [name]: newValue,
        }));

        if (name === 'paymentOninstallments') {
            setShowDetails(checked);
        }
    };

    const [installments, setInstallments] = useState([
        {
            id: 1,
            date: "",
            amount: "",
            paymentMethod: "",
            transfer: "",
            acc: "",
            attachment: null,
            status: 'initial'
        }
    ]);

    const addInputField = () => {
        setInstallments(prev => [
            ...prev,
            {
                id: prev.length + 1,
                date: "",
                amount: "",
                paymentMethod: "",
                transfer: "",
                acc: "",
                attachment: null,
                status: 'initial'
            }
        ]);
    };

    const deleteInputField = (id) => {
        setInstallments(prev => prev.filter(field => field.id !== id));
    };
    const handleInstallmentChange = (id, e) => {
        const { name, value, files } = e.target;

        setInstallments(prev =>
            prev.map(field =>
                field.id === id
                    ? {
                        ...field,
                        [name]: files ? files[0] : value
                    }
                    : field
            )
        );
    };

    const { showMessage } = props;
    const commonAttachments = allowedAttachmentsImages();
    const [donorImage, setDonorImage] = useState({ file: null, fileToSend: null, fileName: null });
    function uploadDonorFile(e) {
        if (e.target.files == null || e.target.files.length <= 0)
            return
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        setDonorImage({
            file: URL.createObjectURL(e.target.files[0]),
            fileToSend: e.target.files[0],
            fileName: e.target.files[0].name
        })

    }
    const [errorMessages, setErrorMessages] = useState({
        errorNote: false,
        errorEditorMaxValue: false,
    });
    const donorFile = useRef(null);

    const donFile = () => {

        donorFile.current.click();
    };

    const [lstOrganization, setLstOrganization] = useState([]);
    const [lstProgram, setLstProgram] = useState([{
        label: 'Choose Program',
        value: ''
    }]);

    const loadOrganization = () => {
        PostDataAPI("fdngrantdonor/loadGrid").then((result) => {
            if (result.success && result.data) {
                setLstOrganization(result.data.map(t => { return { donorId: t.donorId, label: t.donorName, value: t.donorName } }));
            }
        })
    }

    const loadProgram = () => {
        PostDataAPI("fdngrantprograms/loadGrid").then((result) => {
            if (result.success && result.data) {

                setLstProgram(prev => [
                    ...prev,
                    ...result.data.map(t => ({
                        programId: t.programId,
                        label: t.name,
                        value: t.programId
                    }))
                ]);
            }
        })
    }

    const Validate = (errorList) => {


        if (!state.programId) {
            setErrorMessages(prev => ({ ...prev, errorProgramId: true }));
            errorList.push(true);
        } else {
            setErrorMessages(prev => ({ ...prev, errorProgramId: false }));
        }

        if (selectedDonorType === "installment") {

        } else if (selectedDonorType === "oneTime") {
            if (!state.disbursedAmount) {
                setErrorMessages(prev => ({ ...prev, errorDisbursedAmount: true }));
                errorList.push(true);
            } else {
                setErrorMessages(prev => ({ ...prev, errorDisbursedAmount: false }));
            }


            if (!state.paymentMethod) {
                setErrorMessages(prev => ({ ...prev, errorPaymentMethod: true }));
                errorList.push(true);
            } else {
                setErrorMessages(prev => ({ ...prev, errorPaymentMethod: false }));
            }

            if (!state.paymentMethod) {
                setErrorMessages(prev => ({ ...prev, errorPaymentMethod: true }));
                errorList.push(true);
            } else {
                setErrorMessages(prev => ({ ...prev, errorPaymentMethod: false }));
            }
        }




        if (!state.disbursementNotes) {
            setErrorMessages(prev => ({ ...prev, errorDisbursementNotes: true }));
            errorList.push(true);
        } else {
            setErrorMessages(prev => ({ ...prev, errorDisbursementNotes: false }));
        }




    }

    const addDisbursed = () => {
        let errorList = [];
        Validate(errorList);

        if (errorList.length > 0) return;

        setIsLoading(true);

        const formData = new FormData();

        // append main form fields
        Object.keys(state).forEach(key => {
            if (state[key] !== undefined && state[key] !== null) {
                formData.append(key, state[key]);
            }
        });

        formData.append("Status", "Pending");

        if (selectedDonorType === "installment") {
            installments.forEach((i, index) => {
                formData.append(
                    `installments[${index}].installmentAmount`,
                    Number(i.amount)
                );


                formData.append(
                    `installments[${index}].installmentDate`,
                    new Date(i.date).toISOString()
                );

                formData.append(
                    `installments[${index}].paymentMethod`,
                    i.paymentMethod
                );

                formData.append(
                    `installments[${index}].paymentReference`,
                    i.acc || i.transfer || ""
                );

                formData.append(
                    `installments[${index}].paymentType`,
                    "Installment"
                );

                formData.append(
                    `installments[${index}].attachmentFilePath`,
                    i.attachmentFilePath || ""
                );

                // file upload
                if (i.attachmentFile) {
                    formData.append(
                        `installments[${index}].attachmentFile`,
                        i.attachmentFile
                    );
                }
            });
        } else {
            formData.append("installments", false);
        }



        // append installments array


        PostDataAPI("fdngrantdisbursement/add", formData)
            .then((result) => {
                setIsLoading(false);

                if (result.success && result.data) {
                    handleSuccessClose();
                }
            });
    };




    useEffect(() => {
        loadOrganization();
        loadProgram()
    }, [])

    return (
        <>
            <Dialog
                maxWidth="md"
                className={classes.DialogWidth}
                open={isOpen}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >

                <div className={classes.dialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>
                                Cash Disbursement
                            </Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>
                    </div>
                </div>

                {isLoading ? <DialogLoader></DialogLoader> : ""}

                <Scrollbars autoHeight autoHeightMax={570}>
                    <div className={classes.content}>

                        <Grid container spacing={4}>

                            <Grid item xs={12} md={6} >
                                <Label size={12} title="Choose Program" />
                                <SelectField options={lstProgram}
                                    onChange={handleChange}
                                    placeholder={"Select Program"}
                                    name="programId"
                                    id="programId"
                                    value={state.programId} />

                                {errorMessages.errorProgramId && !state.programId ? (
                                    <FormHelperText style={{ color: "red" }}>Please choose program</FormHelperText>
                                ) : ""}
                            </Grid>


                            <Grid item xs={12} md={6} >

                                <Label size={12} title="Payment Type" />
                                <Grid item xs={10} className={classes.radioInfo}>
                                    <FormControl>
                                        <RadioGroup
                                            id="paymentType"
                                            name="paymentType"
                                            value={state.paymentType}
                                            onChange={handleOptionChange}
                                        >
                                            <FormControlLabel value="oneTime" control={<Radio />} label="One Time Payment" />
                                            <FormControlLabel value="installment" control={<Radio />} label="Payment on Installment" />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>



                        </Grid>




                        {selectedDonorType === "oneTime" && (
                            <>
                                <Grid container spacing={4}>
                                    <Grid item xs={12} md={6}>
                                        <Label size={12} title="Amount" />
                                        <InputBaseField
                                            id="disbursedAmount"
                                            name="disbursedAmount"
                                            type="number"
                                            value={state.disbursedAmount}
                                            onChange={handleChange}
                                            placeholder='Amount'
                                            IsDisabled={false}
                                            MaxLength={80}
                                        />

                                        {errorMessages.errorDisbursedAmount && !state.disbursedAmount ? (
                                            <FormHelperText style={{ color: "red" }}>Please enter amount..</FormHelperText>
                                        ) : ""}

                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <Label size={12} title="Payment Method" />
                                        <SelectField
                                            id="paymentMethod"
                                            name="paymentMethod"
                                            options={[
                                                { label: "Select Payment Method", value: "" },
                                                { label: "Bank Transfer", value: "Bank Transfer" },
                                                { label: "Cash", value: "Cash" },
                                                { label: "Cheque", value: "Cheque" },
                                                { label: "Online Payment", value: "Online" }
                                            ]}
                                            value={state.paymentMethod}
                                            onChange={handleChange}
                                        />

                                        {errorMessages.errorPaymentMethod && !state.paymentMethod ? (
                                            <FormHelperText style={{ color: "red" }}>Please choose payment method..</FormHelperText>
                                        ) : ""}
                                    </Grid>

                                </Grid>

                                <Grid container spacing={4}>
                                    <Grid item xs={12} md={6}>
                                        <Label size={12} title="Trx/Acct ./Cheque #" />
                                        <InputBaseField
                                            id="acc"
                                            name="acc"
                                            type="text"
                                            // value={state.firstName}
                                            onChange={handleChange}
                                            placeholder='Trx/Acct ./Cheque #'
                                            IsDisabled={false}
                                            MaxLength={80}
                                        />

                                    </Grid>
                                    <Grid item xs={12} md={6} >
                                        <Label size={12} title="Attached Document" />
                                        <input
                                            ref={inputFile}
                                            id="attachedDocument"
                                            name="attachedDocument"
                                            type="file"
                                            MaxLength={80}
                                            onChange={handleChange}
                                            style={{ display: "none" }}
                                        />
                                        <div className={classes.BrowseMain}>
                                            <InputBaseField
                                                type="text"
                                                // value={bannerImage.fileName ? bannerImage.fileName : state.bannerName}
                                                placeholder={"Attached if any"}
                                                MaxLength={80}
                                                onChange={(e) => { }}
                                                className={classes.fileInput}
                                                readOnly={true}
                                                onPaste={(e) => e.preventDefault()}
                                                onDrop={(e) => e.preventDefault()}
                                            />
                                            <a className={"BrowseButton"} onClick={handleFileUpload}>
                                                Browse
                                            </a>
                                        </div>
                                    </Grid>
                                </Grid>
                            </>
                        )}

                        {selectedDonorType === "installment" && (
                            <Grid container spacing={4}>
                                <Grid item xs={12}>
                                    {installments.map((field, index) => (
                                        <div className={classes.FlexMain} key={field.id}>
                                            <div className={classes.flexInput}>
                                                <Label title='Date' />
                                                <InputBaseField
                                                    id="date"
                                                    name="date"
                                                    type="date"
                                                    // value={state.firstName}
                                                    onChange={(e) => handleInstallmentChange(field.id, e)}
                                                    IsDisabled={false}
                                                />
                                            </div>
                                            <div className={classes.flexInput}>
                                                <Label title='Amount' />
                                                <InputBaseField
                                                    id="amount"
                                                    name="amount"
                                                    type="text"
                                                    // value={state.firstName}
                                                    onChange={(e) => handleInstallmentChange(field.id, e)}
                                                    IsDisabled={false}
                                                />
                                            </div>
                                            <div className={classes.flexInput}>
                                                <Label size={12} title="Payment Method" />
                                                <SelectField
                                                    id="paymentMethod"
                                                    name="paymentMethod"
                                                    options={[
                                                        { label: "Select Payment Method", value: "" },
                                                        { label: "Bank Transfer", value: "Bank Transfer" },
                                                        { label: "Cash", value: "Cash" },
                                                        { label: "Cheque", value: "Cheque" },
                                                        { label: "Online Payment", value: "Online" }
                                                    ]}
                                                   // value={state.paymentMethod}
                                                    onChange={(e) => handleInstallmentChange(field.id, e)}
                                                />
                                            </div>
                                            <div className={classes.flexInput}>
                                                <Label title='Cheque/Wire Tranfer' />
                                                <InputBaseField
                                                    id="transfer"
                                                    name="transfer"
                                                    type="text"
                                                    // value={state.firstName}
                                                    onChange={(e) => handleInstallmentChange(field.id, e)}
                                                    IsDisabled={false}
                                                />
                                            </div>
                                            <div className={classes.flexInput}>
                                                <Label title='Trx/Acct ./Cheque #' />
                                                <InputBaseField
                                                    id="acc"
                                                    name="acc"
                                                    type="text"
                                                    // value={state.firstName}
                                                    onChange={(e) => handleInstallmentChange(field.id, e)}
                                                    IsDisabled={false}
                                                />
                                            </div>
                                            <div className={classes.flexInput}>
                                                <Label title="Attachment" />

                                                <input
                                                    ref={donorFile}
                                                    type="file"
                                                    name="attachmentFile"
                                                    style={{ display: "none" }}
                                                    onChange={(e) => handleInstallmentChange(field.id, e)}
                                                />

                                                <div className={classes.BrowseMain}>
                                                    <InputBaseField
                                                        type="text"
                                                        className={classes.FileInput}
                                                        readOnly
                                                        value={
                                                            field.attachmentFile
                                                                ? field.attachmentFile.name
                                                                : field.attachmentFilePath || ""
                                                        }
                                                        onPaste={(e) => e.preventDefault()}
                                                        onDrop={(e) => e.preventDefault()}
                                                        IsDisabled={false}
                                                    />

                                                    <a
                                                        onClick={() => donorFile.current.click()}
                                                        className="BrowseButtonCenter"
                                                    >
                                                        {field.attachmentFile
                                                            ? '' :  "Browse"}
                                                    </a>
                                                </div>
                                            </div>

                                            {field.id > 1 && (
                                                <div className={classes.flexInput}>

                                                    <a onClick={() => deleteInputField(field.id)}>
                                                        <img src={addDonorIcon} className={classes.AddIconDelete} alt="Delete Icon" />
                                                    </a>
                                                </div>
                                            )}
                                            <div className={classes.flexInput}>
                                                <a onClick={addInputField}>
                                                    <img src={addDonorIcon} className={classes.AddIcon} alt="Add Donor Icon" />
                                                </a>
                                            </div>

                                        </div>
                                    ))}
                                </Grid>
                            </Grid>
                        )}




                        <Grid container>
                            <Grid item xs={12}>
                                <Label size={12} title="Disbursement Purpose" />
                                <TextareaField
                                    id="disbursementNotes"
                                    name="disbursementNotes"
                                    type="text"
                                    rowsMin={4}
                                    value={state.disbursementNotes}
                                    onChange={handleChange}
                                    placeholder='Detail or purpose of grant disbursement'
                                    IsDisabled={false}
                                    MaxLength={80}
                                />

                                {errorMessages.errorDisbursementNotes && !state.disbursementNotes ? (
                                    <FormHelperText style={{ color: "red" }}>Please write disbursement purpose</FormHelperText>
                                ) : ""}
                            </Grid>


                        </Grid>
                    </div>


                </Scrollbars>
                <div className={classes.footer}>
                    <div className={classes.footerRight}>
                        <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                        <Button className={classes.changeBtn} onClick={addDisbursed}>Add New </Button>

                    </div>
                </div>
            </Dialog>
        </>
    )
}


export default withSnackbar(AddCashDisbursement);
